import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function SEO() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  SEO Services Agency That Drives Organic Growth & Sales
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                Our structured approach strengthens search visibility and
                attracts high-intent users. We optimize every aspect of your
                online presence to increase rankings and drive qualified
                traffic.
                {!state.auth.isMobile
                  ? "Google Play Policies with android application development with services we provide value and superb usability to your clients."
                  : ""}
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Brand-Focused"
                  subtitle1="Custom-built for your business identity."
                  title2="Performance-Driven"
                  subtitle2="Created to deliver measurable results."
                  title3="Intuitive Design"
                  subtitle3="Effortless to manage and update."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>SEO Solutions for Higher Rankings and Better Visibility</h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we execute SEO strategies that deliver
                measurable results.
                <br />
                <ul>
                  {" "}
                  <li>
                    <b>
                      Our team handles technical optimization and link-building
                      to augment website performance.
                    </b>
                  </li>
                  <li>
                    <b>
                      We make sure your site ranks for relevant search queries
                      and connects with the right audience.
                    </b>
                  </li>
                  <li>
                    <b>
                      Our tailored strategy drives organic traffic and improves
                      conversions.
                    </b>
                  </li>
                </ul>
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/seo.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our SEO Process"}
            invert={!dark}
            step1={"Technical SEO and Site Optimization"}
            step1description={
              "We audit website structure and fix issues affecting rankings. Our team improves page speed and mobile responsiveness. We also implement schema markup to improve search engine understanding."
            }
            step2={"Keyword Strategy and On-Page SEO"}
            step2description={
              "We research high-intent keywords and map them to relevant pages. Our team optimizes metadata and improves internal linking. We also refine content structure to improve readability and engagement."
            }
            step3={"Content Development and Optimization"}
            step3description={
              "We create and refine content that matches precisely with user intent. Our team enriches existing pages and develops strategic blog topics. We also integrate semantically relevant terms to strengthen keyword relevance."
            }
            step4={"Authority Building and Link Acquisition"}
            step4description={
              "We secure high-quality backlinks from authoritative sources. Our team focuses on natural link-building strategies. We also optimize internal linking to distribute authority across key pages."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our SEO Services"}
            title1={"Stronger Search Visibility"}
            subtitle1={
              "We optimize websites to rank higher for competitive search queries. This improves online presence and increases organic reach."
            }
            title2={"Higher-Quality Traffic"}
            subtitle2={
              "We target users with intent to convert. This approach attracts visitors who are more likely to engage with your business."
            }
            title3={"Sustainable Rankings"}
            subtitle3={
              "We implement SEO techniques that drive long-term growth. Our optimization methods align with search engine algorithms."
            }
            title4={"Improved Website Performance"}
            subtitle4={
              "We enrich technical elements that impact rankings. Faster load times and mobile-friendly designs improve user experience."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>Growing Your Online Business With SEO Marketing</h2>}
            subtitle="At Riches Media Digital, we concentrate and work on expanding your online reach and attracting high-intent customers. Search Engine Optimization (SEO) enriches a website’s visibility by improving rankings for relevant search queries. It involves technical optimization and keyword targeting. It further encircles content strategy to create value-driven pages that engage users. Businesses need structured SEO strategies that adapt to evolving trends as search algorithms change. Our approach strengthens domain authority and builds credibility."
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/seo1.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What SEO Services Will You Get"}
            invert={!dark}
            title1={"Technical SEO Expertise"}
            title2={"Data-Driven Keyword Strategies"}
            title3={"High-Quality Content Optimization"}
            title4={"Authority Link-Building Techniques"}
            title5={"Continuous Performance Tracking"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is SEO?"
            a1="SEO improves a website’s visibility on search engines. It involves technical optimization and keyword targeting. We further work on content strategy to increase rankings. Businesses use SEO to attract relevant traffic and improve conversions."
            q2="Why is SEO important for my business?"
            a2="SEO increases organic traffic and strengthens online authority. A well-optimized website attracts more users and improves lead generation. Businesses that invest in SEO gain long-term visibility and reduce reliance on paid advertising."
            q3="How long does SEO take to show results?"
            a3="SEO is a long-term strategy. Websites start seeing improvements within three to six months based on competition and industry trends. Consistent optimization leads to sustainable growth and higher rankings over time."
            q4="What are the key factors that affect SEO rankings?"
            a4="Search rankings depend on technical SEO, content relevance, and website authority. Search engines prioritize fast-loading and mobile-friendly websites with high-quality content and strong backlink profiles."
            q5="How do you choose the right keywords?"
            a5="We conduct competitive research and search intent analysis to identify high-performing keywords. Our team prioritizes low-competition and high-conversion keywords that align with business goals."
            q6="How can I measure SEO success?"
            a6="SEO success is measured through organic traffic growth and conversion rates. We track search impressions and engagement metrics to refine strategies. Regular performance reports highlight progress and improvement areas."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
